import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  FACILITATOR_VALIDATION_CLEAR,
  FACILITATOR_VALIDATION_FETCH_DOMAINS,
} from '../../../../actions/actionTypes';

const domains = fetchReducerGenerator(
  FACILITATOR_VALIDATION_CLEAR,
  FACILITATOR_VALIDATION_FETCH_DOMAINS
);

export default domains;

export const getFacilitatorValidationDomains = ({ response: { data = [] } }) =>
  data
    .sort((a, b) => b.counter - a.counter)
    .map(({ domainId, counter, url }) => ({
      key: domainId,
      value: `${url} (${counter})`,
    }));
